/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rounds_Seating_OkInputs */



/**
* | output |
* | --- |
* | "OK ({count} expected)" |
*
* @param {Rounds_Seating_OkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_ok = /** @type {((inputs: Rounds_Seating_OkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_OkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`OK (${i?.count} attendu)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Aceptable (${i?.count} esperados)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`OK (${i?.count} esperado)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`OK (${i?.count} previsti)`)
	return /** @type {LocalizedString} */ (`OK (${i?.count} expected)`)
});